import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { LoginPage } from '../pages/LoginPage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/login')({
  component: Login,
  beforeLoad: () => {
    const { isAuthenticated } = useAuthStore.getState()
    if (isAuthenticated) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
})

function Login() {
  const navigate = useNavigate()

  const handleNavigateToRegister = () => {
    navigate({ to: '/register' })
  }

  const handleLoginSuccess = () => {
    navigate({ to: '/dashboard' })
  }

  return (
    <LoginPage
      onNavigateToRegister={handleNavigateToRegister}
      onLoginSuccess={handleLoginSuccess}
    />
  )
}